// One rule for showing a transaction as money in or money out, used by the
// Transactions list, the dashboard and the export.
// Income is in; expense, refund and other types are out (unchanged).
// Transfers come from the bank's sign only:
//   1. a negative stored amount is out;
//   2. otherwise the saved bank direction (t.direction: 'in' / 'out'),
//      recorded at import from the bank's sign or debit/credit column;
//   3. otherwise 'unknown' - shown for review, never assumed to be money in.
// Description keywords are only a suggestion (suggestedDirection) for review.

const OUT_WORDS = /\b(payment\s+to|transfer\s+to|to|withdrawal)\b/i;
const IN_WORDS = /\b(transfer\s+from|from|deposit)\b/i;

export function suggestedDirection(text) {
  const s = String(text || '');
  const out = s.search(OUT_WORDS);
  const inn = s.search(IN_WORDS);
  if (out === -1 && inn === -1) return null;
  if (out === -1) return 'in';
  if (inn === -1) return 'out';
  return out < inn ? 'out' : 'in';
}

export function transferDirection(t) {
  if (Number(t?.amount) < 0) return 'out';
  const saved = String(t?.direction || '').toLowerCase();
  if (saved === 'in' || saved === 'out') return saved;
  return 'unknown';
}

export function transactionDirection(t) {
  const type = String(t?.transaction_type || '').toLowerCase();
  if (type === 'income') return 'in';
  if (type === 'transfer') return transferDirection(t);
  return 'out';
}

export function needsDirection(t) {
  return transactionDirection(t) === 'unknown';
}

export function signedAmountText(t, formatCurrency) {
  const dir = transactionDirection(t);
  const sign = dir === 'in' ? '+' : dir === 'out' ? '-' : '?';
  return sign + formatCurrency(Math.abs(Number(t?.amount) || 0));
}

export function directionClass(t) {
  const dir = transactionDirection(t);
  if (dir === 'unknown') return 'text-amber-600';
  return dir === 'in' ? 'text-green-600' : 'text-red-600';
}

export function directionLabel(t) {
  const dir = transactionDirection(t);
  if (dir === 'unknown') return 'Needs review';
  return dir === 'in' ? 'In' : 'Out';
}
